$.fn.m6Toggler = function() {
	return this.each(function() {
		var $me = $(this),
			target = $(this).data('toggle'),
			targetName = target.replace(/\.|#/g, '');

		$(this).on('click', function(e) {
			e.preventDefault();

			$(this).toggleClass('toggler-on');
			$(target).toggleClass('toggle-on');
			$('body').toggleClass(targetName + '-toggle-on');
		});

		$(document).on('click', function(e) {
			if (!$(e.target).is($me) && !$(e.target).is(target)) {

				$me.removeClass('toggler-on');
				$(target).removeClass('toggle-on');
				$('body').removeClass(targetName + '-toggle-on');
			}
		});
	});
};

$('[data-toggle]').m6Toggler();